import { InnerContentItem, OuterContentItem } from "@certn/cascadia-react";
import { ArrayControlProps } from "@jsonforms/core";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { CascadiaJsonFormContext } from "../../../../forms/src/CascadiaJsonFormContext";
import { dataToFile } from "../../utils";
import { QualifyingEmployer } from "./types";
import { findEmployerById, getEmploymentDocumentTypeLabel } from "./utils";

type EmploymentDocument = {
  employer_id: string;
  employment_document: string;
  document_type: string;
};

export function EmploymentDocumentsSummaryControl(props: ArrayControlProps) {
  const { t } = useTranslation();
  const { values: rootValues } = useContext(CascadiaJsonFormContext);
  const qualifyingEmployers = (props.uischema?.options?.qualifying_employers ??
    []) as QualifyingEmployer[];
  const documentTypesByEmployerId = Object.fromEntries(
    qualifyingEmployers.map((employer) => [
      employer.employer_id,
      employer.document_types ?? [],
    ])
  );

  const employers = rootValues?.employment_history?.employers || [];
  const documents = props.data as EmploymentDocument[];

  return (
    <>
      {documents?.map((document, index) => {
        const employer = findEmployerById(employers, document.employer_id);
        const summary = [
          employer.company_name,
          employer.position,
          employer.start_date,
        ]
          .filter(Boolean)
          .join(" - ");
        const filename = dataToFile(document.employment_document)?.name;
        const documentType = getEmploymentDocumentTypeLabel(
          document.document_type,
          documentTypesByEmployerId[document.employer_id] ?? []
        );

        return (
          <OuterContentItem
            key={index}
            title={filename}
            subtitle={`${summary}: ${documentType}`}
            testID={`employment-documents-summary-${index + 1}`}
          >
            <InnerContentItem
              label={t("Document")}
              testID={`employment-documents-summary-document-${index + 1}`}
            >
              {filename}
            </InnerContentItem>
            <InnerContentItem
              label={t("Employer")}
              testID={`employment-documents-summary-employer-${index + 1}`}
            >
              {summary}
            </InnerContentItem>
            <InnerContentItem
              label={t("Document type")}
              testID={`employment-documents-summary-document-type-${index + 1}`}
            >
              {documentType}
            </InnerContentItem>
          </OuterContentItem>
        );
      })}
    </>
  );
}
